import { render, staticRenderFns } from "./activityView.vue?vue&type=template&id=c530053c&scoped=true"
import script from "./activityView.vue?vue&type=script&lang=js"
export * from "./activityView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c530053c",
  null
  
)

export default component.exports